import { MailOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import { Localizable } from '@components/localizable/Localizable'
import Page from '@components/Page/Page'
import { TextEditorVariable } from '@components/tiptap/tiptap-ui/variables-dropdown/variables-dropdown'
import { CommunicationKey } from '@models/Communication'
import { NotificationContentKey } from '@models/NotificationContent'
import { useAppDispatch } from '@store/hooks'
import { getNotificationContents } from '@store/NotificationContentReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Permission } from '@utils/permissions'
import { Col, Divider, Flex, Row } from 'antd'
import { useEffect } from 'react'

const BusinessNotificationsPage = () => {
  const dispatch = useAppDispatch()

  const fetchSettings = () => {
    dispatch(
      getNotificationContents([
        NotificationContentKey.BUSINESS_COMPANY_CONTACT_CONFIRMATION_ADD,
        NotificationContentKey.BUSINESS_COMPANY_CONTACT_ADDED,
        NotificationContentKey.BUSINESS_PROFILE_LINKING_CODE,
      ])
    )
  }
  useEffect(() => {
    fetchSettings()
  }, [])

  return (
    <Localizable>
      <Page permissions={Permission.manageBusiness}>
        <Flex vertical gap={100}>
          <Flex vertical gap={0}>
            <PageTitle
              title="Business notifications"
              level={4}
              style={{ margin: 0 }}
              toolbar={<Localizable.LangSelector />}
            />
            <Divider />
            <Row gutter={[32, 32]}>
              <Col span={24}>
                <FormCard
                  title="Company created"
                  icon={<MailOutlined />}
                  entity={Entity.notificationContent}
                  action={SBRMAction.Update}
                  metadata={[
                    {
                      key: MetadataKey.NotificationContent,
                      value:
                        NotificationContentKey.BUSINESS_COMPANY_CONTACT_CONFIRMATION_ADD,
                    },
                    {
                      key: MetadataKey.textEditorVariables,
                      value: [
                        TextEditorVariable.FIRST_NAME,
                        TextEditorVariable.LAST_NAME,
                      ],
                    },
                    {
                      key: MetadataKey.Communication,
                      value:
                        CommunicationKey.EMAIL_COMPANY_CONTACT_INVITATION_CONFIRMATION_ADD,
                    },
                  ]}
                />
              </Col>
              <Col span={24}>
                <FormCard
                  title="Company contact added by another company contact"
                  icon={<MailOutlined />}
                  entity={Entity.notificationContent}
                  action={SBRMAction.Update}
                  metadata={[
                    {
                      key: MetadataKey.NotificationContent,
                      value:
                        NotificationContentKey.BUSINESS_COMPANY_CONTACT_ADDED,
                    },
                    {
                      key: MetadataKey.textEditorVariables,
                      value: [
                        TextEditorVariable.FIRST_NAME,
                        TextEditorVariable.LAST_NAME,
                      ],
                    },
                    {
                      key: MetadataKey.Communication,
                      value:
                        CommunicationKey.EMAIL_COMPANY_CONTACT_INVITATION_ADDED,
                    },
                  ]}
                />
              </Col>
              <Col span={24}>
                <FormCard
                  title="Employee profile code issued"
                  icon={<MailOutlined />}
                  entity={Entity.notificationContent}
                  action={SBRMAction.Update}
                  metadata={[
                    {
                      key: MetadataKey.NotificationContent,
                      value:
                        NotificationContentKey.BUSINESS_PROFILE_LINKING_CODE,
                    },
                    {
                      key: MetadataKey.textEditorVariables,
                      value: [
                        TextEditorVariable.FIRST_NAME,
                        TextEditorVariable.LAST_NAME,
                        TextEditorVariable.CODE,
                      ],
                    },
                    {
                      key: MetadataKey.Communication,
                      value: CommunicationKey.EMAIL_BUSINESS_PROFILE_CODE,
                    },
                  ]}
                />
              </Col>
            </Row>
          </Flex>
        </Flex>
      </Page>
    </Localizable>
  )
}

export default BusinessNotificationsPage
